import { render } from "./StatisticsExpensesOnTravels.vue?vue&type=template&id=21655c3c&scoped=true"
import script from "./StatisticsExpensesOnTravels.vue?vue&type=script&lang=js"
export * from "./StatisticsExpensesOnTravels.vue?vue&type=script&lang=js"

import "./StatisticsExpensesOnTravels.vue?vue&type=style&index=0&id=21655c3c&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21655c3c"]])

export default __exports__